import {
  Alert,
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Skeleton,
  Snackbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stringToColor } from "utils/randomColor";
import {
  getAdminThunk,
  getDistributorThunk,
  getFillingPersonThunk,
  getCustomerThunk,
  getMachineAdminThunk,
  getLocationAdminThunk,
  clearState,
  activateAccountThunk,
  deActivateAccountThunk,
} from "store/reducers/accounts";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Masonry } from "@mui/lab";
import {
  FcCellPhone,
  FcAddressBook,
  FcInfo,
  FcDiploma2,
  FcPhoneAndroid,
  FcGlobe,
} from "react-icons/fc";
import { IoLocationSharp } from "react-icons/io5";
import { IconContext } from "react-icons";
import StyledBadge from "components/StyledBadge";
import StyledBadgeNormal from "components/StyledBadgeNormal";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";

const ProfileView = ({ mod }) => {
  const accountState = useSelector((state) => state.accounts);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);
  useEffect(() => {
    if (mod === "admin") {
      dispatch(getAdminThunk());
    } else if (mod === "distributor") {
      dispatch(getDistributorThunk());
    } else if (mod === "fillingPerson") {
      dispatch(getFillingPersonThunk());
    } else if (mod === "machineAdmin") {
      dispatch(getMachineAdminThunk());
    } else if (mod === "locationAdmin") {
      dispatch(getLocationAdminThunk());
    } else if (mod === "customer") {
      dispatch(getCustomerThunk());
    }
  }, [dispatch, mod]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [contextMenu, setContextMenu] = React.useState(null);
  const open = Boolean(anchorEl);
  const [snackBarOpen, setSnackBarOpen] = useState(
    accountState.errorActivate || accountState.successActivate
  );
  const [currentItem, setCurrentItem] = React.useState(null);

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setCurrentItem(item);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setContextMenu(null);
  };

  const handleSnackClose = () => {
    setSnackBarOpen(false);
  };

  useEffect(() => {
    setSnackBarOpen(accountState.errorActivate || accountState.successActivate);
  }, [accountState.errorActivate, accountState.successActivate]);

  const handleAccountActivation = () => {
    console.log("ci", currentItem);
    if (currentItem?.is_active) {
      dispatch(deActivateAccountThunk(currentItem.id));
    } else {
      dispatch(activateAccountThunk(currentItem.id));
    }
  };

  const handleContextMenu = (event, item) => {
    event.preventDefault();
    setCurrentItem(item);
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
          }
        : null
    );
  };

  const getAvatar = (profileData) => {
    if (profileData.profile_completed) {
      if (profileData.profile.photo) {
        return (
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            variant="dot"
            active={profileData.is_active}
          >
            <Avatar
              src={`http://dev.gnowee.in:4001${profileData.profile.photo} `}
            />
          </StyledBadge>
        );
      } else {
        return (
          <StyledBadge
            overlap="circular"
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            variant="dot"
            active={profileData.is_active}
          >
            <Avatar sx={{ bgcolor: stringToColor(profileData.username) }}>
              {profileData.username[0]}
            </Avatar>
          </StyledBadge>
        );
      }
    } else {
      return (
        <StyledBadgeNormal
          overlap="circular"
          variant="dot"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          active={profileData.is_active}
        >
          <Avatar sx={{ bgcolor: stringToColor(profileData.username) }}>
            {profileData.username[0]}
          </Avatar>
        </StyledBadgeNormal>
      );
    }
  };

  // accountState[`${mod}s`].length === 0 &&
  return (
    <Box maxWidth>
      <Masonry columns={{ lg: 3, md: 2, sm: 1 }} spacing={1.5}>
        {accountState.loadingList &&
          accountState[`${mod}s`].length === 0 &&
          Array(3)
            .fill("")
            .map((item, index) => (
              <Card key={index} elevation={3} sx={{ width: "100%" }}>
                <CardHeader
                  avatar={
                    <Skeleton variant="circular" width={40} height={40} />
                  }
                  titleTypographyProps={{ variant: "h5" }}
                  title={
                    <Typography variant="h4">
                      <Skeleton animation="wave" />
                    </Typography>
                  }
                  subheader={
                    <Typography variant="subtitle2">
                      <Skeleton animation="wave" />
                    </Typography>
                  }
                />
                <CardContent sx={{ paddingY: 0 }}>
                  {Array(4)
                    .fill("")
                    .map((index, key) => (
                      <Box key={key} display="flex" marginTop={1}>
                        <Skeleton variant="circular" width={24} height={24} />
                        <Typography marginLeft={1} flex={1}>
                          <Skeleton animation="wave" />
                        </Typography>
                      </Box>
                    ))}
                  <Box display="flex" justifyContent="space-between">
                    <Typography marginTop={1} flex={1} marginRight={2}>
                      <Skeleton animation="wave" />
                    </Typography>
                    <Typography marginTop={1} flex={1} marginLeft={2}>
                      <Skeleton animation="wave" />
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            ))}

        {accountState.errorCreate && (
          <Alert sx={{ mt: 3, width: "100%" }} severity="error">
            Error occurred
          </Alert>
        )}

        {accountState[`${mod}s`].length > 0 &&
          accountState[`${mod}s`].map((profileData) => (
            <Card
              key={profileData.id}
              elevation={3}
              sx={{ width: "100%" }}
              onContextMenu={(e) => handleContextMenu(e, profileData)}
            >
              <CardHeader
                avatar={getAvatar(profileData)}
                action={
                  <IconButton
                    aria-owns={open ? "long-menu" : undefined}
                    aria-label="settings"
                    onClick={(e) => handleClick(e, profileData)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                }
                titleTypographyProps={{ variant: "h5" }}
                title={`@${profileData.username}`}
                subheader={
                  profileData.profile
                    ? new Date(profileData.profile.created_date).toDateString()
                    : ""
                }
              />
              <CardContent sx={{ paddingY: 0 }}>
                {profileData.phone && (
                  <Box display="flex">
                    <IconContext.Provider value={{ color: "navy", size: 24 }}>
                      <FcCellPhone fontSize="large" />
                    </IconContext.Provider>

                    <Typography marginLeft={1}>{profileData.phone}</Typography>
                  </Box>
                )}
                {profileData.email && (
                  <Box display="flex" marginTop={1}>
                    <IconContext.Provider value={{ color: "navy", size: 24 }}>
                      <FcAddressBook />
                    </IconContext.Provider>

                    <Typography marginLeft={1}>{profileData.email}</Typography>
                  </Box>
                )}

                {profileData.profile && (
                  <Box display="flex" marginTop={1}>
                    <IconContext.Provider value={{ color: "navy", size: 24 }}>
                      <FcInfo />
                    </IconContext.Provider>

                    <Typography
                      marginLeft={1}
                    >{`${profileData.profile.first_name} ${profileData.profile.last_name}`}</Typography>
                  </Box>
                )}
                {profileData.profile?.employee_id && (
                  <Box display="flex" marginTop={1}>
                    <IconContext.Provider value={{ color: "navy", size: 24 }}>
                      <FcDiploma2 />
                    </IconContext.Provider>

                    <Typography marginLeft={1}>
                      {profileData.profile.employee_id}
                    </Typography>
                  </Box>
                )}
                {profileData.profile?.secondary_phone && (
                  <Box display="flex" marginTop={1}>
                    <IconContext.Provider value={{ color: "navy", size: 24 }}>
                      <FcPhoneAndroid />
                    </IconContext.Provider>

                    <Typography marginLeft={1}>
                      {profileData.profile.secondary_phone}
                    </Typography>
                  </Box>
                )}
                {profileData.profile?.address && (
                  <Box display="flex" marginTop={1}>
                    <Box sx={{ flexGrow: 1 }}>
                      <IconContext.Provider value={{ color: "navy", size: 24 }}>
                        <FcGlobe />
                      </IconContext.Provider>
                    </Box>

                    <Typography marginLeft={1}>
                      {profileData.profile.address}
                    </Typography>
                  </Box>
                )}
                {profileData.profile?.location && (
                  <Box display="flex" marginTop={1}>
                    <IconContext.Provider value={{ color: "navy", size: 24 }}>
                      <IoLocationSharp />
                    </IconContext.Provider>

                    <Typography marginLeft={1}>
                      {profileData.profile.location}
                    </Typography>
                  </Box>
                )}

                <Box display="flex" justifyContent="space-between">
                  {profileData.profile?.gst && (
                    <Typography marginTop={1}>
                      GSTIN : {profileData.profile.gst}
                    </Typography>
                  )}
                  {profileData.profile?.va_no && (
                    <Typography marginTop={1}>
                      VA : {profileData.profile.gst}
                    </Typography>
                  )}
                </Box>
              </CardContent>
            </Card>
          ))}
      </Masonry>

      <Menu
        anchorEl={anchorEl}
        open={anchorEl !== null}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleAccountActivation}>
          <ListItemIcon>
            {currentItem?.is_active ? (
              <PersonOffIcon fontSize="small" />
            ) : (
              <InsertEmoticonIcon fontSize="small" />
            )}
          </ListItemIcon>
          {currentItem?.is_active ? "Deactivate account" : "Activate account"}
        </MenuItem>
      </Menu>
      <Menu
        open={contextMenu !== null}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
      >
        <MenuItem onClick={handleAccountActivation}>
          <ListItemIcon>
            {currentItem?.is_active ? (
              <PersonOffIcon fontSize="small" />
            ) : (
              <InsertEmoticonIcon fontSize="small" />
            )}
          </ListItemIcon>
          {currentItem?.is_active ? "Deactivate account" : "Activate account"}
        </MenuItem>
      </Menu>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={handleSnackClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackClose}
          severity={accountState.successActivate ? "success" : "error"}
          sx={{ width: "100%" }}
        >
          {accountState.successActivate
            ? `Successfully ${
                currentItem?.is_active ? "Deactivated" : "Activated"
              } user !`
            : `Error occurred while ${
                currentItem?.is_active ? "Deactivating" : "Activating"
              } user !`}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ProfileView;
